/* eslint-disable */
const view = {
  index: 1,
  create: 2,
  edit: 3,
  management: 4
}
import access from './access'
import plan from './plan'
export default {
  mixins: [plan, access],
  data: () => ({
    // field_errors para validoções que buscam no banco
    field_errors: [],
    valid: false,
    dialog: false,
    loading: false,
    view: view.index,
    previousView: view.index,
    search: '',
    // Usado para armazenar o valor que estão de acordo com o banco de dados. Para que quando ir em close, retornar os valroes corretamente para tela de gerenciamento
    editedItemDB: {},
    allItems: [],
    items: [],
    editedItem: {},
    beforeEditedItem: {},
    defaultItem: {},
    dialogConfirm: false
  }),
  methods: {
    initialize() {
      this.$store.commit('loader/change_dialog', true)
      this.$http.get(`api/${this.entity}`).then(res => {
        this.items = JSON.parse(JSON.stringify(res.body))
        this.allItems = JSON.parse(JSON.stringify(res.body))
        this.afterInitialize(res.body)
      })
    },
    afterInitialize(values) {
      this.redoFilter(values)
    },
    create(resetForm = true) {
      if (this.beforeCreate() !== false) {
        this.previousView = this.view
        this.view = view.create
        this.dialog = this.view != 1
        // Verifica se o form já está criado, se estiver da reset nos campos, para zerar as validações
        if (resetForm && this.$refs.form) {
          this.$refs.form.resetValidation()
        }

        //Foi incluido o setTimeout pois quando da um reset no form precisa d eum tempo para jogar os valores novamente
        // setTimeout(function () {
        this.editedItem = Object.assign(JSON.parse(JSON.stringify(this.defaultItem)), '')
        // Ao criar verifica se tem algum item com ref-autofocus se tiver foca no campo que possui o ref=autofocus
        if (this.$refs.autofocus) {
          this.$nextTick(() => this.$refs.autofocus.focus())
        }
        this.afterCreate()
        // }, 10)
      }
    },
    editItemProcess(item, view) {
      this.$store.commit('loader/change_dialog', true)
      this.$http.get(`api/${this.entity}/${item.id}`).then((res) => {
        this.editItem(res.body, view)
        this.$store.commit('loader/change_dialog', false)
      }, err => {
        this.$store.commit('loader/change_dialog', false)
        if (err.body.message === 'actionDenied') {
          this.$store.commit('snackbar/change_values', { text: 'Apenas os administradores da empresa podem gerenciá-la.', timeout: 10000, color: 'warning', dialog: true })
          this.$router.push('/access-denied')
        } else {
          this.$store.commit('snackbar/change_values', { text: 'Não foi possível acessar o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true })
        }
      })
    },
    editItem(item, view = 3) {
      this.errors.clear()
      this.beforeEditItem(item, view)
      this.previousView = this.view
      this.view = view
      this.dialog = this.view != 1

      Object.assign(this.editedItemDB, JSON.parse(JSON.stringify(item)))
      Object.assign(this.editedItem, JSON.parse(JSON.stringify(item)))
      // Criado o beforeEditedItem para caso sejá necessário aceesar algum dado antes da alteração deste
      Object.assign(this.beforeEditedItem, JSON.parse(JSON.stringify(item)))
      this.afterEditItem(item)
      let _this = this
      // incluido o setTimeout pois sem ele o arquivos da tarefa não funciona o foco
      setTimeout(function () {
        // Ao editar verifica se tem algum item com ref-autofocus se tiver foca no campo que possui o ref=autofocus
        if (_this.$refs.autofocus) {
          _this.$nextTick(() => _this.$refs.autofocus.focus())
        }
      }, 10)
    },
    dialogDelete(item) {
      this.dialogConfirm = true
      // editedItem = item tem que ser = se não não pega vinculo quando tenta encontrar o index no deleteItem 
      this.editedItem = item
    },
    closeDialogDelete() {
      this.dialogConfirm = false
      this.editedItem = Object.assign(JSON.parse(JSON.stringify(this.defaultItem)), {})
    },
    deleteItem(params = '') {
      // Before usado para ter os valores completos mesmo depois de deletar como ao recusar um convite de parceria
      Object.assign(this.beforeEditedItem, JSON.parse(JSON.stringify(this.editedItem)))
      this.$store.commit('loader/change_dialog', true)
      // verifica se é diferente de false, pois quando a função não possui return ela deve continuar o processo
      if (this.beforeDelete(this.editedItem) !== false) {
        this.$http.delete(`api/${this.entity}/${this.editedItem.id}${params}`).then(
          (res) => {
            // utilizado o splice pois ao atribuir valor diretamente a uma variavel a referencia do ponteiro é alterada
            this.items.splice(this.items.findIndex((val) => {
              return val.id === res.body.id
            }), 1)
            this.allItems.splice(this.allItems.findIndex((val) => {
              return val.id === res.body.id
            }), 1)
            this.afterDelete(res.body)
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: 'Registro de ' +
                this.translate('table.' + this.entity + '.title')[0] +
                ' excluído com sucesso!',
              color: 'success',
              dialog: true
            })
          },
          err => {
            console.log(err)
            if (err.body.message === 'passwordDoesntMatch') {
              this.$store.commit('loader/change_dialog', false)
              this.$store.commit('snackbar/change_values', {
                text: 'Senha invalida!',
                color: 'warning',
                dialog: true
              })
            } else {
              this.$store.commit('loader/change_dialog', false)
              this.$store.commit('snackbar/change_values', {
                text: 'Não foi possível deletar o registro de ' +
                  this.translate('table.' + this.entity + '.title')[0] +
                  ', reporte o erro.',
                color: 'error',
                dialog: true
              })
            }
          }
        )
      } else {
        this.$store.commit('loader/change_dialog', false)
      }
      this.closeDialogDelete()
    },
    close(time = 0, viewAfterSave = 1) {
      this.beforeClose(viewAfterSave)
      // Se a tela é de edição e a tela anterior era de gerenciamento, manter o dialog "true" para voltar para a tela de gerenciamento
      if (this.previousView === 4) {
        if (this.view === 3) {
          this.$socket.emit('leaveRoom', {
            room: `${this.socketRoom}_${this.editedItem.id}_edit`
          })
        }
        viewAfterSave = 4
      }
      // Se view = 4, ou seja, tela de gerenciamento. Retiramos o usuário da sala em que ele estava anteriormente (edição).
      if (this.view == 4)
        this.$socket.emit('leaveRoom', {
          room: `${this.socketRoom}_${this.editedItem.id}`
        })
      let oldValues = this.editedItem
      setTimeout(() => {
        this.previousView = this.view
        this.view = viewAfterSave
        this.dialog = this.view != 1
        if (this.view == view.management) {
          this.editedItem = Object.assign(this.editedItem, JSON.parse(JSON.stringify(this.editedItemDB)))
          this.beforeEditedItem = Object.assign(this.beforeEditedItem, JSON.parse(JSON.stringify(this.editedItemDB)))
        } else {
          this.editedItem = Object.assign(JSON.parse(JSON.stringify(this.defaultItem)), {})
          this.beforeEditedItem = Object.assign(JSON.parse(JSON.stringify(this.defaultItem)), {})
        }
        this.loading = false
        this.afterClose(oldValues)
      }, time)
    },
    // paramentro unshift serve apra definir se o registro será incluido no fim ou no inicio dos itens
    save(viewAfterSave = 1, unshift = false) {
      if ((this.$refs.form && !this.$refs.form.validate()) || (this.$refs.userIllis && !this.$refs.userIllis.validate())) {
        this.$store.commit('snackbar/change_values', {
          text: 'Por favor, corrija as validações antes de salvar!',
          color: 'warning',
          dialog: true
        })
        return false
      }
      this.loading = true
      this.$store.commit('loader/change_dialog', true)
      if (this.view === 2) {
        // verifica se é diferente de false, pois quando a função não possui return ela deve continuar o processo
        if (this.beforeInsert(this.editedItem) !== false) {
          this.$http.post('api/' + this.entity, this.editedItem).then(
            (res) => {
              this.editedItemDB = res.body
              if (unshift) {
                this.items.unshift(JSON.parse(JSON.stringify(res.body)))
                this.allItems.unshift(JSON.parse(JSON.stringify(res.body)))
              } else {
                this.items.push(JSON.parse(JSON.stringify(res.body)))
                this.allItems.push(JSON.parse(JSON.stringify(res.body)))
              }
              this.afterInsert(res.body)
              // A verificação da próxima tela a ser aberta(viewAfterSave) é feita dentro do post, pois o Items precisa ter incluido pelo o push os valores
              // para que a próxima tela a ser aberta funcione corretamente
              if (viewAfterSave === 2) {
                this.create()
                // viewAfterSave === 3 usado quando salva um formulário pela automação
              } else if (viewAfterSave === 3 || viewAfterSave === 4) {
                this.editItem(this.editedItemDB, viewAfterSave)
              } else {
                // Close é chamado dentro do post para que o OtherField funcione corretamente, passando os valores para os Items e depois carregando o othersfields
                this.close(0, viewAfterSave)
              }
              this.loading = false
              this.$store.commit('loader/change_dialog', false)
              this.$store.commit('snackbar/change_values', {
                text: 'Registro de ' +
                  this.translate('table.' + this.entity + '.title')[0] +
                  ' incluído com sucesso!',
                color: 'success',
                dialog: true
              })
            },
            err => {
              console.log(err)
              this.$store.commit('loader/change_dialog', false)
              this.loading = false
              this.$store.commit('snackbar/change_values', {
                text: 'Não foi possível incluir o registro de ' +
                  this.translate('table.' + this.entity + '.title')[0] +
                  ', reporte o erro.',
                color: 'error',
                dialog: true
              })
            })
        } else {
          this.$store.commit('loader/change_dialog', false)
          this.loading = false
        }
      } else if (this.view >= 3) {
        let editedItem = this.editedItem
        // verifica se é diferente de false, pois quando a função não possui return ela deve continuar o processo
        if (this.beforeUpdate(this.editedItem) !== false) {
          this.$http.put('api/' + this.entity + '/' + this.editedItem.id,
            this.editedItem).then(
              (res) => {
                this.editedItemDB = res.body
                Object.assign(this.items.find((val) => {
                  return val.id === this.editedItem.id
                }) || {}, res.body)
                Object.assign(this.allItems.find((val) => {
                  return val.id === this.editedItem.id
                }) || {}, res.body)
                this.afterUpdate(res.body, this.beforeEditedItem)
                this.close(0, viewAfterSave)
                this.$store.commit('loader/change_dialog', false)
                this.loading = false
                this.$store.commit('snackbar/change_values', {
                  text: 'Registro de ' +
                    this.translate('table.' + this.entity + '.title')[0] +
                    ' editado com sucesso!',
                  color: 'success',
                  dialog: true
                })
              },
              err => {
                console.log(err)
                this.$store.commit('loader/change_dialog', false)
                this.loading = false
                this.$store.commit('snackbar/change_values', {
                  text: 'Não foi possível editar o registro de ' +
                    this.translate('table.' + this.entity + '.title')[0] +
                    ', reporte o erro.',
                  color: 'error',
                  dialog: true
                })
              }
            )
        } else {
          this.$store.commit('loader/change_dialog', false)
          this.loading = false
        }
      }
    },
    saveNew() {
      this.save(view.create)
    },
    saveEdit() {
      this.save(view.management)
    },
    saveValue(route, values, name = '', editItem = false) {
      if (this.beforeSaveValue(values) !== false) {
        this.loading = true
        this.$store.commit('loader/change_dialog', true)
        this.$http.post('api/' + route, values).then(
          (res) => {
            if (editItem) {
              this.items.push(res.body)
              this.allItems.push(res.body)
            }
            this.$store.commit('loader/change_dialog', false)
            this.loading = false
            this.$store.commit('snackbar/change_values', {
              text: 'Registro' + (name === '' ? name : ' de ' + name) +
                ' incluído com sucesso!',
              color: 'success',
              dialog: true
            })
            this.afterSaveValue(res.body)
            this.close()
          },
          err => {
            console.log(err)
            this.$store.commit('loader/change_dialog', false)
            this.loading = false
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível incluir o registro' +
                (name === '' ? name : ' de ' + name) + ', reporte o erro.',
              color: 'error',
              dialog: true
            })
          })
      }
    },
    deleteValue(route, value, name = '', editItem = false) {
      if (this.beforeDeleteValue(value) !== false) {
        this.$store.commit('loader/change_dialog', true)
        this.$http.delete(`api/${route}/${value.id}`).then(
          (res) => {
            if (editItem) {
              this.items = this.items.filter(
                (val) => {
                  return val.id !== value.id
                })
              this.allItems = this.allItems.filter(
                (val) => {
                  return val.id !== value.id
                })
            }
            this.afterDeleteValue(value)
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: 'Registro' + (name === '' ? name : ' de ' + name) +
                ' excluído com sucesso!',
              color: 'success',
              dialog: true
            })
          },
          err => {
            console.log(err)
            this.$store.commit('loader/change_dialog', false)
            // Não é permitido excluir um status ou categoria que possui tarefas
            if (err.body.message === 'hasTask') {
              this.$store.commit('snackbar/change_values', { text: 'Não é possível excluir esse item, pois está sendo usado em outras tarefas!', color: 'warning', dialog: true })
            } else {
              this.$store.commit('snackbar/change_values', { text: 'Não foi possível excluir o registro' + (name === '' ? name : ' de ' + name) + ', reporte o erro.', color: 'error', dialog: true })
            }
          }
        )
      } else {
        this.$store.commit('loader/change_dialog', false)
      }
      this.closeDialogDelete()
    },
    editValue(route, value, name = '', editItem = false, redoFilter = true) {
      if (this.beforeEditValue(value) !== false) {
        this.$store.commit('loader/change_dialog', true)
        this.$http.put('api/' + route + '/' + value.id, value).then(
          (res) => {
            if (editItem) {
              Object.assign(this.items.find(
                (res) => {
                  return res.id === value.id
                }) || {}, res.body)
              Object.assign(this.allItems.find(
                (res) => {
                  return res.id === value.id
                }) || {}, res.body)
              if (this.allItems.length > 0) {
                if (redoFilter) {
                  this.redoFilter(this.allItems)
                }
              }
            }
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: 'Registro' + (name === '' ? name : ' de ' + name) +
                ' editado com sucesso!',
              color: 'success',
              dialog: true
            })
            this.afterEditValue(res.body)
            this.close()
          },
          err => {
            console.log(err)
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {
              text: 'Não foi possível editar o registro' +
                (name === '' ? ' de ' + name : name) + ', reporte o erro.',
              color: 'error',
              dialog: true
            })
          }
        )
      }
    },
    beforeCreate() { },
    afterCreate() { },
    beforeEditItem(oldValues) { },
    afterEditItem(oldValues) { },
    beforeEditValue(oldValues) { },
    afterEditValue(newValues) { },
    beforeSaveValue(oldValues) { },
    afterSaveValue(newValues) { },
    beforeDeleteValue(oldValues) { },
    afterDeleteValue(oldValues) { },
    beforeInsert(oldValues) { },
    afterInsert(newValues) {
      // Refaz o filtro depois que insere
      this.redoFilter(this.allItems)
    },
    beforeUpdate(oldValues) { },
    afterUpdate(newValues, oldValues) {
      // Refaz o filtro depois que edita
      this.redoFilter(this.allItems)
    },
    beforeDelete(oldValues) { },
    afterDelete(oldValues) { },
    beforeClose(viewAfterSave) { },
    afterClose() { },
    redoFilter(values) {
      // Usado para executar o filtro padrão do usuário. Assim é carregado todos os valores para o filtro funcionar
      // É usado um get para buscar o user pois this.$auth.user() não busca o filtro do usuário atualizado
      let filterInterval = setInterval(() => {
        // setInterval para verificar quando termina de carregar o filtro do usuário
        if (this.$store.getters[`filter/loaded`]) {
          if (this.$refs.filter) {
            let userFilter = this.$store.getters[`filter/values`]
            this.$refs.filter.userFilter = userFilter || {}
            this.$refs.filter.filter = {}
            // verifica se existe o filtro
            if ((userFilter || {})[this.entity]) {
              this.$refs.filter.filter = userFilter[this.entity] || {}
            }
            if (Object.keys(this.$refs.filter.filter).length > 0) {
              this.$refs.filter.customFilter(values)
            }
          }
          // Desabilita o loading
          this.$store.commit('loader/change_dialog', false)
          clearInterval(filterInterval)
        }
      }, 100)
    },
    getMaxValue(arr, prop) {
      let max = 0
      // Foi utilizado o reduce para percorrer o array e retornar o maior valor entre os campos de acordo com a "prop"(algum campo do array)
      if (arr.length > 0) {
        max = arr.map(function (val) {
          return val[prop]
        }).reduce(function (a, b) {
          return Math.max(a, b)
        })
      }
      return (max || 0)
    },
    filterAutocomplete(item, queryText, itemText) {
      const hasValue = val => val != null ? val : ''
      const text = hasValue(itemText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      const query = hasValue(queryText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      return text.indexOf(query) > -1
    },
    doubleFilterAutocomplete(item, queryText, itemText) {
      const textOne = item.id_text.toLowerCase()
      const textTwo = item.email.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
    },
    customizedFilter(items, search, filter) {
      search = search.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      let fieldSearch = this.headers.map(function (val) {
        let dots = val['value'].split('.').length
        if (dots >= 2) {
          let reduce = val['value'].substring(0, val['value'].indexOf('.'))
          if (dots >= 3) {
            let reduce2 = val['value'].substring(10, val['value'].indexOf('.id_text'))
            return [reduce, 3, reduce2]
          }
          return [reduce, 2]
        } else {
          return [val['value'], 1]
        }
      })
      return items.filter((item) => (
        fieldSearch.some((j) => {
          if (j[1] === 1) {
            return item[j[0]] ? filter(item[j[0]].toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''), search) : false;
          } else if (j[1] === 2) {
            return item[j[0]] && item[j[0]]['id_text'] ? filter(item[j[0]]['id_text'].toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''), search) : false;
          } else {
            return item[j[0]] && item[j[0]][j[2]] && item[j[0]][j[2]]['id_text'] ? filter(item[j[0]][j[2]]['id_text'].toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''), search) : false;
          }
        })
      ))
    }
  },
  computed: {
    socketRoom: function () {
      return `${this.entity || ''}${this.$auth.user().company_id}`
    },
    customFilter: function () {
      return function (field = 'id_text', data = null) {
        return data ? data.filter((item) => {
          return item[field].toString().toLowerCase().match(this.search.toLowerCase())
        }) : this.items.filter((item) => {
          let register = item[field].toString().toLowerCase().match(this.search.toLowerCase())
          if (register) return register
        })
      }
    },
    formTitle() {
      switch (this.view) {
        case 1:
          return this.translate('system.title.consult') +
            this.translate('table.' + this.entity + '.title')[1]
        case 2:
          return this.translate('system.title.include') +
            this.translate('table.' + this.entity + '.title')[0]
        case 3:
          return this.translate('system.title.edit') +
            this.translate('table.' + this.entity + '.title')[0]
        case 4:
          return this.translate('system.title.management') +
            this.translate('table.' + this.entity + '.title')[0]
      }
    },
    emptyTable() {
      return 'Ainda não foram cadastrados registros de ' + this.translate('table.' + this.entity + '.title')[1]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/crud.js